import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';
import { TextMaskModule } from 'angular2-text-mask';
import { CommonService } from '../../../common/service/common.service';

import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';

export interface Address {
	Tipo: string;
	Telefone: string;
}

import 'moment/locale/pt-br';

import * as _ from 'underscore';

// Model
import { AccountStructure } from '../../../models/account-structure'

// Service
import { AccountClientDetailsService } from '../../service/account-client-edit/account-client-details.service';
import { AppComponent } from '../../../app.component';
import { DialogService } from "ng2-bootstrap-modal";
import { ConfirmComponent } from "../../../shared/confirm/confirm.component";
import { SerasaConfirmComponent } from './serasa-confirm/serasa-confirm.component';
import { RelatoComponent } from '../../../serasa/component/serasa/relato/relato.component';
import { ConcentreComponent } from '../../../serasa/component/serasa/concentre/concentre.component';
import { CrednetComponent } from '../../../serasa/component/serasa/crednet/crednet.component';
import { ProposalViewModalComponent } from './proposal-view-modal/proposal-view-modal.component';
import { OrderViewModalComponent } from './order-view-modal/order-view-modal.component';
import { AlcadaAlertComponent } from './alcada-alert/alcada-alert.component';
import { IMyDpOptions } from 'mydatepicker';
import { EditLcComponent } from './edit-lc/edit-lc.component';
import { SolicitarLcAdicionalComponent } from './solicitar-lc-adicional/solicitar-lc-adicional.component';
import { LimiteAdicionalProposalService } from '../../../limite-adicional-proposal/service/limite-adicional-proposal/limite-adicional-proposal.service';
import { AttachmentsenderService } from '../../../attachmentsender/service/attachmentsender.service';

@Component({
	selector: 'app-account-client',
	templateUrl: './account-client-details.component.html',
	styleUrls: ['./account-client-details.component.css'],
	providers: [
		AccountClientDetailsService,
		AttachmentsenderService,
		LimiteAdicionalProposalService,
		HttpModule,
		CommonService
	],
	moduleId: module.id
})

export class AccountClientDetailsComponent implements OnInit {
	public guid: string;
	public loadProposal: boolean = false;
	public loadLimiteAdicionalProposal: boolean = false;
	private sub: any;
	customermanual: FormGroup;
	public cepMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
	private showEconomicGroups = false; //Control Tab state
	private showAttachs = false; //Control Tab state
	private showFinancial = false; //Control Tab state
	private showSerasa = false; //Control Tab state
	private showGuarantees = false; //Control Tab state
	private dateTest = new Date();

	//Controla os IDs de Propostas LC e Alçada e Crédito adicional
	private creditProposalData;	

	private clientByGroupList = [];
	private token;
	private empresa;
	public nullComment: string = "";
	public conceitoCobrancaJ: string = "";
	public structureclientCTC: any[] = [];
	public accountClientHistory: any[] = [];
	public accountClientDetails = {
		AdiantamentoLC: '',
		Apelido: '',
		Bairro: '',
		BloqueioManual: '',
		CEP: '',
		Cidade: '',
		ClientePremium: '',
		CodigoPrincipal: '0',
		Complemento: '',
		ContaClienteEstruturaComercial: [],
		ContaClienteFinanceiro: [],
		ContaClienteRepresentante: [],
		Contato: '',
		DataNascimentoFundacao: '',
		Documento: '0',
		Email: '',
		Endereco: '',
		GrupoEconomicos: [],
		ID: '',
		Nome: '',
		Numero: '',
		OutrosCodigo: [],
		Pais: '',
		PropostaLcs: [],
		RestricaoSerasa: '',
		TipoConsultaSolicitanteSerasaID: 0,
		SegmentoID: '',
		TOP10: '',
		Telefone: '',
		TipoClienteID: '',
		TipoCliente: null,
		UF: '',
		PendenciaSerasa: 0
	};
	public hasTJ = false;
	public validMail = true;
	public validCEP = true;
	public accountClientTypeID: any[] = [];
	public TipoCliente: any[] = [];
	public accountClientType: any[] = [];
	public accountAllClientTypes: any[] = [];
	public accountClientFinancialDetails: any[] = [];
	public accountClientFinancialDetailsRaw: any[] = [];
	public accountClientFinancialTitulos: any = null;
	public accountClientFinancialDetailsLimits: any[] = [];
	public accountClientLogs: any[] = [];
	public accountClientComments: any[] = [];
	public accountClientCommentDescription: string = "";
	public currentDate = moment(new Date(new Date().setHours(0,0,0,0))).format("YYYY-MM-DD HH:mm:ss");
	public accountClientCodePrincipal: string = "";
	public accountClientLogUser: string = "";
	public accountClientLogBeginDate: any = "";
	public accountClientLogEndDate: any = "";
	public accountClientDataNascimentoFundacao: any = "";
	public accountClientDetailsSegmentoID: any[] = [];
	public accountClientDetailsSegmento: any[] = [];

	// Controle do Loader
	public showLoader = false;
	
	// Lista de todos os segmentos
	public allSegmentList: any[] = [];

	public accountClientOrderTotals = {
		BuscaOrdemPagaRetira: [],
		BuscaOrdemVendaAVista: [],
		BuscaOrdemVendaPrazos: [],
		ClienteId: '',
		EmpresaId: ''
	};
	public proposals: any[] = [];
	public salesOrderFollow: any[] = [];

	// Controles para buscas do usuário
	public searchOrderVista = false;
	public searchOrderPrazo = false;
	public searchOrderRetira = false;
	public temGrupoEconomigo = false;
	public editingClient = false;
	public editingClientFinanceiro = false;
	public restricaoSerasaEditValue = 0;
	public conceitoCobrancaEditValue = 0;
	public percPddEditValue = 0;
	public sinistroEditValue = false;
	public estruturasComerciais: AccountStructure[];

	// Grupo Economico Compartilhado
	public sharedEconomicGroup = [];

	// Segmento
	public segmentClientID;
	public segmentClient: any[] = [];

	public accountClientPhones: any[] = [];
	public clientTypeCheck: any[] = [];
	public myForm: FormGroup; // our form model
	public clienteBloqueado: boolean = false;
	public permissoes: any[] = [];
	public proposalAvailable: any[] = [];
	public structureAvailable: any[] = [];
	private proposalBloqued: boolean;
	public numeroOrdemVenda: string;
	public ordersVista: any[] = [];
	public ordersPrazo: any[] = [];
	public ordersRetira: any[] = [];
	
	// Liberação conceito cobrança
	public conceptbillings: any[] = [];
	public comentarioLiberacao: string;
	public clientID: string = "";
	public clientName: string = "";

	// Propostas
	public orderbyPropostas: string = "Codigo";
	public sortPropostas: string = "asc";

	// Ordens a Prazo
	public resultCountPrazo: number = 0;
	public orderbyPrazo: string = "DataRemessa";
	public sortPrazo: string = "asc";
	currentPagePrazo: number = 0;
	public selectedOrders: any[] = [];
	public selectedOrdersOB: any[] = [];
	public selectedOrdersOL: any[] = [];

	// Ordens a Vista
	public resultCountVista: number = 0;
	public orderbyVista: string = "DataRemessa";
	public sortVista: string = "asc";
	currentPageVista: number = 0;

	// Ordens a Retirar
	public resultCountRetira: number = 0;
	public orderbyRetira: string = "DataRemessa";
	public sortRetira: string = "asc";
	currentPageRetira: number = 0;
	public profileUser: string = "";
	public action: string = "";
	public id: string = "";
	public tempGroup: any[] = [];
	public loadPropostaAlcada: boolean = false;
	public loadExtraProposta: boolean = false;
	private alcadaExists;
	private propostaLcAdicionalExists;
	private dataFundacao;
	public states: any[] = [];
	private today = moment();

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		disableSince: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};
	constructor(
		fb: FormBuilder, 
		private accountClientDetailsService: AccountClientDetailsService, 
		private limiteAdicionalProposalService: LimiteAdicionalProposalService, 
		private attachmentsenderService: AttachmentsenderService , 
		private commonService: CommonService, 
		private flashMessagesService: FlashMessagesService, 
		private router: Router, private route: ActivatedRoute, 
		private _fb: FormBuilder, 
		private dialogService: DialogService) {
		this.token = localStorage.getItem('yara.token');
		this.empresa = localStorage.getItem('yara.selectedCompany');
	}

	getState() {
		this.commonService.getState(this.token).subscribe(result => {
			if (result.Success) {
				this.states = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	dateTeste() {
		let teste = document.getElementById("testInput");
		console.log("tipo do elemento", teste)
		//if ( test.type != 'date' ) $('#test').datepicker();
	}

	ngOnInit() {	
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		this.sub = this.route.params.subscribe(params => {
			this.guid = params['guid'];
			this.action = params['action'];
			this.id = params['id'];
		});

		//this.getAccountClientDetails();
		this.getCreditProposal();
		this.checkProposalAvailable();

		$(".account-details-readyonly .form-group input").hide();

		this.myForm = this._fb.group({
			Tipo: this._fb.array([]),
			Telefone: this._fb.array([]),
		});

		this.getState();
		this.addPhoneNumber();
		this.listAllSegmentTypes();
		this.getBillingConcept();
		this.getClientGroupList();
		//this.getAccountClientFinancialDetails();
		this.getUserProfileByClient();
		this.checkAccountClientTribunal();

		switch (this.action) {
			case 'proposta-lc':
				setTimeout(() => { 
					this.requestProposal(false);
				}, 1000);
				break;

			case 'cobranca':
				setTimeout(() => {
					$(".billing-tab a").trigger("click");
					this.showFinancial = true;
				}, 1000);
				break;

			case 'garantia':
				setTimeout(() => {
					$(".guarantee-tab a").trigger("click");
					this.showGuarantees = true;
				}, 1000);
				break;

			case 'ordem-venda':
				this.numeroOrdemVenda = this.id;
				setTimeout(() => {
					document.getElementById('ordemVenda').scrollIntoView(true);
				}, 300);
				break;

			case 'proposta-prorrogacao':
				setTimeout(() => {
					$(".billing-tab a").trigger("click");
					this.showFinancial = true;
				}, 1000);
				break;

			case 'proposta-alcada':
				this.loadPropostaAlcada = true;
				break;

			case 'proposta-la':
				console.log("proposta-la");
				this.loadExtraProposta = true;
				setTimeout(() => { 
					this.requestProposalLA();
				}, 1000);
				break;

			case 'proposta-abono':
				setTimeout(() => {
					$(".billing-tab a").trigger("click");
					this.showFinancial = true;
				}, 1000);
				break;

			default:
				$('html, body').animate({ scrollTop: 0 }, 0);
				break;
		}
	}

	getBillingConcept() {
		this.accountClientDetailsService.getBillingConceptList().subscribe(result => {
			if (result.Success) {
				this.conceptbillings = result.Result;
				console.log("Conceitos Ativos", this.conceptbillings);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	setOrderPropostas(orderby) {
		if (this.orderbyPropostas != orderby) {
			this.sortPropostas = "asc";
		} else {
			this.sortPropostas = this.sortPropostas == "asc" ? "desc" : "asc";
		}
		this.orderbyPropostas = this.orderbyPropostas != orderby ? orderby : this.orderbyPropostas;
		this.getProposalClient();
	}

	getProposalClient() {
		this.accountClientDetailsService.getProposalClient(this.guid, this.orderbyPropostas, this.sortPropostas).subscribe(result => {
			if (result.Success) {
				this.proposals = result.Result;
				console.log("Propostas", this.proposals);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	clickTitle() {
		$("a[href='#collapseAccountDetail']").trigger("click");
	}

	getLiberacaoOv() {
		this.accountClientDetailsService.getLiberacaoOv(this.guid, 'NumeroProposta', this.sortPropostas).subscribe(result => {
			if (result.Success) {
				this.salesOrderFollow = result.Result;
				console.log("Liberações", this.salesOrderFollow);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	getUserProfileByClient() {
		this.accountClientDetailsService.getUserProfileByClient(this.guid).subscribe(result => {
			if (result.Success) {
				this.profileUser = result.Result;
				console.log("Perfil", this.profileUser);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	openOrdersDetails(empresasID, tipoRemessas) {
		let disposable = this.dialogService.addDialog(OrderViewModalComponent, {
			accountClientID: this.guid,
			empresaID: empresasID,
			tipoRemessa: tipoRemessas
		},
		{
			backdropColor: 'rgba(0, 0, 0, 0.5)' }
		).subscribe((result) => {
			// Do nothing.
		});
	}

	openProposalView(proposalID, proposalCod, status) {
		console.log('openProposalView', proposalID, proposalCod, status);

		var isCurrentPropostaLC = (proposalCod.substring(0, 2) === 'LC' || proposalCod.substring(0, 2) === 'EC') 
			&& (status !== 'Aprovada' && status !== 'Encerrada' && status !== 'Rejeitada'); 
		
		if (isCurrentPropostaLC) {
			this.openLcProposal();
		}
		else {
			let disposable = this.dialogService.addDialog(ProposalViewModalComponent, {
				proposalID: proposalID,
				proposalCod: proposalCod,
				accountClientID: this.guid,
				currentClientDocument: this.accountClientDetails['Documento'],
				tempGroup: this.tempGroup,
				profileUser: this.profileUser,
				segmentoID: this.segmentClientID
			},
			{
				backdropColor: 'rgba(0, 0, 0, 0.5)'
			}).subscribe((result) => {
				// Do nothing.
			});
		} 
	}

	openLcProposal() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID + '/proposta-lc');
			});
	}

	openLaProposal() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID + '/proposta-la');
			});
	}

	openCompetenceProposal() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID + '/proposta-alcada');
			});
	}

	activeCompetenceProposal() {		
		if (this.creditProposalData && this.creditProposalData.PropostaAlcadaID &&
			(this.creditProposalData.PropostaAlcadaStatus !== 'AA' &&
				this.creditProposalData.PropostaAlcadaStatus !== 'AP' &&
				this.creditProposalData.PropostaAlcadaStatus !== 'EN' &&
				this.creditProposalData.PropostaAlcadaStatus !== 'RE')) {
			this.alcadaExists = true;
		} else {
			this.alcadaExists = false;
		}
	}

	activeExtraProposal() {
		if (this.creditProposalData && this.creditProposalData.PropostaLCAdicionalID &&
			(this.creditProposalData.PropostaLCAdicionalStatus !== 'AA' &&
				this.creditProposalData.PropostaLCAdicionalStatus !== 'XE' &&
				this.creditProposalData.PropostaLCAdicionalStatus !== 'XR')) {
			this.propostaLcAdicionalExists = true;
		} else {
			this.propostaLcAdicionalExists = false;
		}
	}

	// requestAccountClientStructureDetails()
	// {
	// 	this.accountClientDetailsService.getAccountClientStructureDetails(this.token, this.guid).subscribe(result => {
	// 		if (result.Success) {
	// 			this.structureAvailable = result.Result;
	// 		}
	// 	}, error => {
	// 		console.log(error);
	// 		return false;
	// 	});
	// }

	// Preparar estrutura comercial (representantes, ctc, gc e diretoria)
	prepareCommercialStructure() {

		var ac: AccountStructure;
		this.estruturasComerciais = [];
		var ecl: AccountStructure[] = [];

		// Representantes
		this.accountClientDetails.ContaClienteRepresentante.sort(e => e.Representante.Nome).forEach(e => {
			var ctc = this.accountClientDetails.ContaClienteEstruturaComercial
			.find(cce => cce.EstruturaComercial.CodigoSap === e.CodigoSapCTC); 
			
			ac = new AccountStructure();
			ac.NomeRepresentante = e.Representante ? e.Representante.Nome : '';
			ac.NomeCTC = ctc ? ctc.EstruturaComercial.Nome : '';
			ac.NomeGC = ctc && ctc.EstruturaComercial && ctc.EstruturaComercial.Superior ? ctc.EstruturaComercial.Superior.Nome : '';
			ac.NomeDC = ctc && ctc.EstruturaComercial && ctc.EstruturaComercial.Superior && ctc.EstruturaComercial.Superior.Superior ? ctc.EstruturaComercial.Superior.Superior.Nome : '';
			ac.CodigoCTC = ctc && ctc.EstruturaComercial.CodigoSap;
			ecl.push(ac);	
		});

		// CTCs sem Representante
		this.accountClientDetails.ContaClienteEstruturaComercial
			.filter(cce => !this.estruturasComerciais
			.find(ecs => ecs.CodigoCTC === cce.EstruturaComercial.CodigoSap))
			.sort(e => e.EstruturaComercial.Nome).forEach(e => {
				
				if(e && e.EstruturaComercial)
				{
					ac = new AccountStructure();
					ac.NomeRepresentante = '';
					ac.NomeCTC = e.EstruturaComercial.Nome;
					ac.NomeGC = e.EstruturaComercial.Superior ? e.EstruturaComercial.Superior.Nome : '';
					ac.NomeDC = e.EstruturaComercial.Superior && e.EstruturaComercial.Superior.Superior ? e.EstruturaComercial.Superior.Superior.Nome : '';
					ecl.push(ac);
				}				
			});

		this.estruturasComerciais = ecl.sort((e1, e2) => {

			if (e1.sortCriteria() < e2.sortCriteria()) return -1;
			if (e1.sortCriteria() > e2.sortCriteria()) return 1;
			return 0;
		});
	}

	requestProposal(isProposalOpen) {
		if (this.creditProposalData && this.creditProposalData.PropostaAlcadaStatus && isProposalOpen) {
			if (this.creditProposalData.PropostaAlcadaStatus === 'EC' ||
				this.creditProposalData.PropostaAlcadaStatus === 'ET' ||
				this.creditProposalData.PropostaAlcadaStatus === 'EA') {
				this.flashMessagesService.show("Não é possível continuar, pois existe uma proposta de Alçada em andamento", { cssClass: 'alert-danger', timeout: 6000 });
			} else {
				if (!this.loadProposal) {
					this.loadProposal = true;
				} else {
					if ($(document).find("a[href='#collapseAccountDetail'").attr("aria-expanded") === "true") {
						$(document).find("a[href='#collapseAccountDetail'").trigger("click");
					}
					$('html, body').animate({ scrollTop: 0 }, 500);
				}
			}
		} else if (this.creditProposalData && this.creditProposalData.PropostaLCAdicionalStatus && isProposalOpen) {
			if (this.creditProposalData.PropostaLCAdicionalStatus != 'AA' &&
				this.creditProposalData.PropostaLCAdicionalStatus != 'XE' &&
				this.creditProposalData.PropostaLCAdicionalStatus != 'XR') {
				this.flashMessagesService.show("Não é possível continuar, pois existe uma proposta de LC adicional em andamento", { cssClass: 'alert-danger', timeout: 6000 });
			} else {
				if (!this.loadProposal) {
					this.loadProposal = true;
				} else {
					if ($(document).find("a[href='#collapseAccountDetail'").attr("aria-expanded") === "true") {
						$(document).find("a[href='#collapseAccountDetail'").trigger("click");
					}
					$('html, body').animate({ scrollTop: 0 }, 500);
				}
			}
		} else {
			if (isProposalOpen) {
				if (this.accountClientDetails && !this.accountClientDetails.SegmentoID) {
					this.flashMessagesService.show("É necessário definir um segmento para o cliente", { cssClass: 'alert-danger', timeout: 6000 });
				}

				if (this.accountClientDetails && this.accountClientDetails.ContaClienteEstruturaComercial.length < 1) {
					this.flashMessagesService.show("É necessário definir uma estrutura comercial para o cliente", { cssClass: 'alert-danger', timeout: 6000 });
				}

				if (this.accountClientDetails && (this.accountClientDetails.SegmentoID && this.accountClientDetails.ContaClienteEstruturaComercial.length > 0)) {
					if (!this.loadProposal) {
						this.loadProposal = true;						
					} else {
						if ($(document).find("a[href='#collapseAccountDetail'").attr("aria-expanded") === "true") {
							$(document).find("a[href='#collapseAccountDetail'").trigger("click");
						}
						$('html, body').animate({ scrollTop: 0 }, 500);
					}
				}
			} else {
				if (!this.loadProposal) {
					if (this.id) {
						this.loadOldProposal(this.id);
					} else {
						this.loadProposal = true;						
					}
				} else {
					if ($(document).find("a[href='#collapseAccountDetail'").attr("aria-expanded") === "true") {
						$(document).find("a[href='#collapseAccountDetail'").trigger("click");
					}
					$('html, body').animate({ scrollTop: 0 }, 500);
				}
			}
		}
	}

	requestProposalLA() {
		if (!this.loadLimiteAdicionalProposal) {
			if (this.id) {
				this.loadOldExtraProposal(this.id);
			} else {
				this.loadLimiteAdicionalProposal = true;
			}
		}
	}

	loadOldProposal(proposalID) {
		this.accountClientDetailsService.getLcProposal(proposalID).subscribe(result => {
			if (result.Success) {
				if (result.Result && result.Result.PropostaLCStatusID) {
					if (result.Result.PropostaLCStatusID == 'AA' ||
						result.Result.PropostaLCStatusID == 'XE' ||
						result.Result.PropostaLCStatusID == 'XR') {
						var propostaStatus = result.Result.PropostaLCStatusID == 'AA' ? 'Aprovada' : result.Result.PropostaLCStatusID == 'XE' ? 'Encerrada' : 'Rejeitada'; 
						this.flashMessagesService.show("Esta proposta foi "+propostaStatus+". Para visualizar consulte utilizando o código.", { cssClass: 'alert-danger', timeout: 6000 });
					} else {
						this.loadProposal = true;
					}
				} else {
					this.loadProposal = true;
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	loadOldExtraProposal(proposalID) {
		this.limiteAdicionalProposalService.getLaProposal(proposalID).subscribe(result => {
			if (result.Success) {
				if (result.Result && result.Result.PropostaLCStatusID) {
					if (result.Result.PropostaLCStatusID == 'AA' ||
						result.Result.PropostaLCStatusID == 'XE' ||
						result.Result.PropostaLCStatusID == 'XR') {
						var propostaStatus = result.Result.PropostaLCStatusID == 'AA' ? 'Aprovada' : result.Result.PropostaLCStatusID == 'XE' ? 'Encerrada' : 'Rejeitada'; 
						this.flashMessagesService.show("Esta proposta foi "+propostaStatus+". Para visualizar consulte utilizando o código.", { cssClass: 'alert-danger', timeout: 6000 });
					} else {						
						this.loadLimiteAdicionalProposal = true;
					}
				} else {					
					this.loadLimiteAdicionalProposal = true;
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	competenceProposalPermission() {

		let permission = true;

		if (!this.accountClientDetails.SegmentoID) {
			this.flashMessagesService.show("É necessário definir um segmento para o cliente.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		if (this.accountClientDetails.ContaClienteEstruturaComercial.length < 1) {
			this.flashMessagesService.show("É necessário definir uma estrutura comercial para o cliente.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		if (!this.accountClientDetails.DataNascimentoFundacao) {
			this.flashMessagesService.show("É necessário informar a Data Nascimento/Fundação do cliente.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		if (this.creditProposalData && this.creditProposalData.PropostaLCAdicionalStatus) {
			if (this.creditProposalData.PropostaLCAdicionalStatus != 'AA' &&
				this.creditProposalData.PropostaLCAdicionalStatus != 'XE' &&
				this.creditProposalData.PropostaLCAdicionalStatus != 'XR') {
				this.flashMessagesService.show("Não é possível continuar, pois existe uma proposta de LC adicional em andamento.", { cssClass: 'alert-danger', timeout: 6000 });
				permission = false;
			}
		}

		if (this.loadProposal) {
			this.flashMessagesService.show("Não é possível continuar, pois existe uma proposta de LC em andamento.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		return permission;
	}

	extraProposalPermission() {

		let permission = true;

		let dadosFinanceiros = this.accountClientFinancialDetailsLimits.find(f => f.EmpresasID === this.empresa);

		if (!dadosFinanceiros.VigenciaFim || (dadosFinanceiros.VigenciaFim && this.currentDate > dadosFinanceiros.VigenciaFim)) {
			this.flashMessagesService.show("Não é possível continuar, pois o cliente não possui LC vigente para empresa selecionada.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		if (!this.accountClientDetails.SegmentoID) {
			this.flashMessagesService.show("É necessário definir um segmento para o cliente.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		if (this.accountClientDetails.ContaClienteEstruturaComercial.length < 1) {
			this.flashMessagesService.show("É necessário definir uma estrutura comercial para o cliente.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		if (!this.accountClientDetails.DataNascimentoFundacao) {
			this.flashMessagesService.show("É necessário informar a Data Nascimento/Fundação do cliente.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		if (this.creditProposalData && this.creditProposalData.PropostaAlcadaStatus) {
			if (this.creditProposalData.PropostaAlcadaStatus === 'EC' ||
				this.creditProposalData.PropostaAlcadaStatus === 'ET' ||
				this.creditProposalData.PropostaAlcadaStatus === 'EA') {
				this.flashMessagesService.show("Não é possível continuar, pois existe uma proposta de Alçada em andamento.", { cssClass: 'alert-danger', timeout: 6000 });
				permission = false;
			}
		}

		if (this.loadProposal ||
			(this.creditProposalData && this.creditProposalData.PropostaLCStatus &&
			this.creditProposalData.PropostaLCStatus != 'AA' &&
			this.creditProposalData.PropostaLCStatus != 'XE' &&
			this.creditProposalData.PropostaLCStatus != 'XR')) {
			this.flashMessagesService.show("Não é possível continuar, pois existe uma proposta de LC em andamento.", { cssClass: 'alert-danger', timeout: 6000 });
			permission = false;
		}

		return permission;
	}

	checkProposalAvailable() {
		this.accountClientDetailsService.checkProposalAvailable(this.token, this.guid).subscribe(result => {
			if (result.Success) {
				this.proposalAvailable = result.Result;
				console.log("TESTE", this.proposalAvailable);
				this.proposalBloqued = !result.Result.UsuarioID && result.Result.PropostaLCID;
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	insertComment(descricao) {

		if (this.accountClientCommentDescription.length <= 1000) {
			this.accountClientDetailsService.insertComment(this.token, this.guid, this.accountClientCommentDescription).subscribe(result => {
				if (result.Success) {
					this.getComments();
					this.searchAccountClientLogs();
					this.accountClientCommentDescription = "";
					$("#comment").focus();

					this.flashMessagesService.show("Mensagem enviada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
		else {
			this.flashMessagesService.show("Esta mensagem excedeu o máximo de caracteres permitidos. (max. 1000 caracteres)", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	getComments() {
		if (this.permissoes['ContaClienteComentario_Visualizar']) {
			this.accountClientDetailsService.getAccountClientComments(this.token, this.guid).subscribe(result => {
				this.accountClientComments = result.Result;
				this.accountClientComments.forEach(element => {
					element.DataCriacao = moment(element.DataCriacao);
				});
			}, error => {
				console.log(error);
			});
		}
	}

	getAccountHistory() {
		if (this.permissoes['ContaCliente_Historico']) {
			this.accountClientDetailsService.accountHistory(this.token, this.guid).subscribe(result => {
				if (result.Success) {
					this.accountClientHistory = result.Result;
				}
			}, error => {
				console.log(error);
				return false;
			});
		}
	}

	getAccountClientDetails() {
		this.accountClientDetailsService.getAccountClientDetails(this.token, this.guid).subscribe(result => {
			if (result.Success) {
				console.log("Pure Account Client Result", result);
				this.reloadClient();
				this.accountClientDetails = result.Result;
				this.structureclientCTC = result.Result.ContaClienteEstruturaComercial ? result.Result.ContaClienteEstruturaComercial.filter(c => c.EstruturaComercial && c.EstruturaComercial.EstruturaComercialPapelID == 'C') : [];
				this.accountClientTypeID = result.Result.TipoClienteID;
				this.clientID = result.Result.ID;
				this.clientName = result.Result.Nome;
				if (result.Result.DataNascimentoFundacao) {
					const tempDate = moment(result.Result.DataNascimentoFundacao);
					this.dataFundacao = { date: { year: tempDate.year(), month: tempDate.month() + 1, day: tempDate.date() } }
				}
				this.clienteBloqueado = result.Result.BloqueioManual;
				this.segmentClientID = result.Result.SegmentoID;
				//this.checkEmailValidation(result.Result.Email);
				this.getAccountClientFinancialDetails();
				this.getAccountClientFinancialDetailsRaw();
				this.validateCEP();
				this.getClientType();
				this.getAccountClientPhone();
				this.searchAccountClientLogs();
				this.getAccountHistory();
				this.getClientSegment();
				this.prepareCommercialStructure();
				if (this.loadPropostaAlcada) {
					setTimeout(() => {
						console.log('carrega-alcada');
						$('html, body').animate({ scrollTop: 0 }, 0);
						if ($(document).find("a[href='#collapseAccountDetail'").attr("aria-expanded") === "true") {
							$(document).find("a[href='#collapseAccountDetail'").trigger("click");
						}
					}, 1000);
				}
				if (this.loadExtraProposta) {
					setTimeout(() => {
						console.log('carrega-proposta-la');
						$('html, body').animate({ scrollTop: 0 }, 0);
						if ($(document).find("a[href='#collapseAccountDetail'").attr("aria-expanded") === "true") {
							$(document).find("a[href='#collapseAccountDetail'").trigger("click");
						}
					}, 1000);
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				this.changeRouteToCockpit();
			}
		}, error => {
			//this.getAccountClientFinancialDetails();
			console.log(error);
		});
	}

	getClientType() {
		this.accountClientDetailsService.getClientTypes(this.token, this.accountClientTypeID).subscribe(result => {
			this.accountClientType = result.Result;
		});
	}

	getAccountClientPhone() {
		this.accountClientDetailsService.getAccountPhone(this.token, this.guid).subscribe(result => {
			this.accountClientPhones = result.Result;
		});
	}

	searchAccountClientLogs() {
		this.accountClientDetailsService.searchAccountClientLogs(this.token, this.accountClientLogBeginDate, this.accountClientLogEndDate, this.accountClientLogUser, this.guid).subscribe(result => {
			this.accountClientLogs = result.Result;
		});
	}

	getAccountClientFinancialDetailsClick() {
		if ($(document).find("a[href='#collapseFinancial'").attr("aria-expanded") === "false") {
			this.getAccountClientFinancialDetails();
		}
	}

	getCreditProposal() {
		this.accountClientDetailsService.getCreditProposal(this.guid).subscribe(result => {
			if (result.Success) {
				this.creditProposalData = result.Result;
				this.getAccountClientDetails();
				console.log("dados da proposta", this.creditProposalData);
				console.log("Resultado do GET IDs de proposta", result);
				this.activeCompetenceProposal();
				this.activeExtraProposal();
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	getAccountClientFinancialDetails() {
		if (this.permissoes['ContaClienteFinanceiro_Visualizar']) {
			this.accountClientDetailsService.getAccountClientFinancialDetails(this.token, this.guid).subscribe(result => {
				this.accountClientFinancialDetails = result.Result ? result.Result : [];
				this.conceitoCobrancaJ = result.Result.ConceitoCobranca ? result.Result.ConceitoCobranca.Nome : '';
				this.accountClientFinancialDetailsLimits = result.Result && result.Result.Limites ? result.Result.Limites : [];

				//this.getLcAndExpositionUserGroups('Y');
				//this.getLcAndExpositionUserGroups('G');

				if (result.Result && result.Result.DescricaoConceito) {
					setTimeout(function () {
						($('[data-toggle="comment-tooltip"]') as any).tooltip();
						($('[data-toggle="comment-tooltip"]') as any).attr('data-original-title', result.Result.DescricaoConceito);
					}, 0);
				}
				this.getComments();
			}, error => {
				this.getComments();
				console.log(error);
			});

			this.accountClientDetailsService.getAccountClientFinancialTitulos(this.token, this.guid).subscribe(result => {
				this.accountClientFinancialTitulos = result.Result ? result.Result : null;
			}, error => {
				console.log(error);
			});
		}
	}

	getAccountClientFinancialDetailsRaw() {
		if (this.permissoes['ContaClienteFinanceiro_Visualizar']) {
			this.accountClientDetailsService.getAccountClientFinancialDetailsRaw(this.token, this.guid).subscribe(result => {
				this.accountClientFinancialDetailsRaw = result.Result ? result.Result : [];
			});
		}
	}

	getLcAndExpositionUserGroups(empresaID) {
		// Se o cliente fizer parte de um Grupo Economico Compartilhado, assume o LC e a Exposição do Grupo e exibe nos dados financeiros do cliente.
		this.accountClientDetailsService.getEconomicGroups(this.accountClientDetails['ID'], empresaID).subscribe(result => {
			if (result.Result) {

				var obj = result.Result.filter(group => group.ClassificacaoID == 1);

				if (obj.length > 0) {
					this.accountClientFinancialDetailsLimits.forEach(element => {
						if (element.EmpresasID === empresaID) {
							this.sharedEconomicGroup['LC'] = obj[0]['LcTotalGrupo'];
							this.sharedEconomicGroup['Exposicao'] = obj[0]['ExpTotalGrupo'];
						}
					});
				}

			}
		}, error => {
			console.log(error);
		});
	}

	cleanMessage() {
		this.nullComment = "";
	}

	setFinancialStatus(comentario, liberar) {

		var data = {
			ContaClienteId: this.clientID,
			Status: liberar,
			ComentarioStatus: comentario
		}

		this.accountClientDetailsService.setFinancialStatus(this.token, data).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Liberação de ordem realizada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				$("#btn-cancelar-libera").trigger("click");
				this.comentarioLiberacao = "";
				this.getAccountClientFinancialDetails();
			} else {
				if (result.Errors[1] === "Campo Comentario de Conceito de Cobrança é obrigatório") {
					this.nullComment = result.Errors[1];
				} else {
					this.nullComment = result.Errors;
				}
			}
		}, error => {
			console.log(error);
		});
	}

	banClient(bloquear) {

		var data = {
			ID: this.clientID,
			Nome: this.clientName,
			BloqueioManual: bloquear
		}

		this.accountClientDetailsService.setCustomermanual(this.token, data).subscribe(result => {
			var msg = "";
			if (bloquear) {
				msg = "Cliente bloqueado com sucesso";
			} else {
				msg = "Cliente desbloqueado com sucesso";
			}
			if (result.Success) {
				this.flashMessagesService.show(msg, { cssClass: 'alert-success', timeout: 6000 });
				this.getAccountClientDetails();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	listAllClientTypes(TipoClienteID) {
		this.accountClientDetailsService.getAllClientTypes(this.token).subscribe(result => {
			this.accountAllClientTypes = result.Result.filter(item => item.Ativo);

			for (var i = this.accountAllClientTypes.length - 1; i >= 0; i--) {
				if (this.accountAllClientTypes[i].ID == TipoClienteID) {
					this.accountAllClientTypes[i].checked = true;
				}
			}
		});
	}

	//List all Active Segments
	listAllSegmentTypes() {
		this.accountClientDetailsService.getAllSegmentTypes(this.token).subscribe(result => {
			this.allSegmentList = result.Result.filter(item => item.Ativo == true);
		});
	}

	//Get Segment from Client
	getClientSegment() {
		if (this.segmentClientID != null) {
			this.accountClientDetailsService.getAccountClientDetailsSegmento(this.token, this.segmentClientID).subscribe(result => {
				this.segmentClient = result.Result;
			});
		}
	}

	onEditEmail(email) {
		this.accountClientDetails.Email = email;
	}

	// checkEmailValidation(email) {
	// 	if (email != '' && email != undefined) {
	// 		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	// 		if (re.test(email) == true) {
	// 			this.validMail = true;
	// 		} else {
	// 			this.validMail = false;
	// 		}
	// 	}
	// }

	initPhoneNumber() {
		return this._fb.group({
			Tipo: [''],
			Telefone: [''],
		});
	}

	addPhoneNumber() {
		const control = <FormArray>this.myForm.controls['Telefone'];
		const addrCtrl = this.initPhoneNumber();
		control.push(addrCtrl);
	}

	clearPhoneNumbers() {
		this.myForm = this._fb.group({
			Tipo: this._fb.array([]),
			Telefone: this._fb.array([]),
		});
	}

	removePhoneNumber(i: number) {
		const control = <FormArray>this.myForm.controls['Telefone'];
		control.removeAt(i);
	}

	removeOldPhoneNumber(i: number) {
		this.accountClientPhones[i].Ativo = false;
	}

	vigenciaLCVencida(vigencia) {
		return vigencia && (this.currentDate < vigencia);
	}

	editClient(TipoClienteID) {
		this.loadProposal = false;
		this.loadLimiteAdicionalProposal = false;
		this.editingClient = true;
		this.listAllClientTypes(TipoClienteID);
		$(".account-details-readyonly .form-group input, .account-details-readyonly .form-group select, .old-phones, #saveClient, #cancelClient, #addMorePhone, .editClient").show();
		$(".account-details-readyonly .editable, #editClient").hide();
		$(".account-details-readyonly .editable, #editCommercialStructure").prop("disabled", true);
		$("#accountClientName").focus();
		this.clearPhoneNumbers();
	}

	editClientFinanc() {
		this.loadProposal = false;
		this.loadLimiteAdicionalProposal = false;
		this.restricaoSerasaEditValue = this.accountClientDetails.PendenciaSerasa;
		this.conceitoCobrancaEditValue = this.accountClientFinancialDetails['ConceitoCobrancaID'] != null ? this.accountClientFinancialDetails['ConceitoCobrancaID'] : null;
		this.percPddEditValue = this.accountClientFinancialDetails['Pdd'] != null ? this.accountClientFinancialDetails['Pdd'] : 0;
		this.sinistroEditValue = this.accountClientFinancialDetails['Sinistro'];
		this.editingClientFinanceiro = true;
	}

	editClientLC() {
		console.log('accountClientFinancialDetailsRaw', this.accountClientFinancialDetailsRaw);

		const dadosYara = this.accountClientFinancialDetailsRaw['Limites'].find(f => f.EmpresasID === 'Y');
		const dadosGalvani = this.accountClientFinancialDetailsRaw['Limites'].find(f => f.EmpresasID === 'G');

		this.dialogService.addDialog(EditLcComponent, {
			ContaClienteId: this.guid,
			limiteYara: dadosYara.LC,
			vigenciaYara: dadosYara.VigenciaFim,
			limiteGalvani: dadosGalvani.LC,
			vigenciaGalvani: dadosGalvani.VigenciaFim
		},
		{ backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe((objToSend) => {
			if (objToSend) {
				this.accountClientDetailsService.updateLimits(objToSend).subscribe(result => {
					if (result.Success) {
						this.flashMessagesService.show('Valores alterados com sucesso!', { cssClass: 'alert-success', timeout: 6000 });
						this.getAccountClientFinancialDetails();
						this.getAccountClientFinancialDetailsRaw();
						this.searchAccountClientLogs();
					} else {
						this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
					}
				});
			}
		});
	}

	cancelClientFinanceiro() {
		this.editingClientFinanceiro = false;
	}

	onSaveFinanceiro() {

		// Serasa
		if (this.restricaoSerasaEditValue != this.accountClientDetails.PendenciaSerasa) {
			this.accountClientDetailsService.saveSerasa(this.guid, this.restricaoSerasaEditValue).subscribe(result => {
				if (result.Success) {
					this.accountClientDetails.PendenciaSerasa = this.restricaoSerasaEditValue;
					this.flashMessagesService.show("Restrição Serasa atualizada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}

		// % PDD / Sinistro
		if (this.percPddEditValue != this.accountClientFinancialDetails['Pdd'] || this.sinistroEditValue != this.accountClientFinancialDetails['Sinistro']) {
			let obj = {
				ContaClienteId: this.guid,
				Pdd: this.percPddEditValue,
				Sinistro: this.sinistroEditValue,
				DataSeguradora: this.accountClientFinancialDetails['DataSeguradora'],
				Conceito: this.accountClientFinancialDetails['Conceito'],
				ConceitoCobrancaID: this.accountClientFinancialDetails['ConceitoCobrancaID']
			}

			this.accountClientDetailsService.updateFinancial(obj).subscribe(result => {
				if (result.Success) {
					this.accountClientDetailsService.cobrancaReload.next(true);
					this.accountClientFinancialDetails['Pdd'] = this.percPddEditValue;
					this.accountClientFinancialDetails['Sinistro'] = this.sinistroEditValue;
					this.flashMessagesService.show("Dados financeiros atualizados com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}

		// Conceito Cobrança
		if (this.conceitoCobrancaEditValue != this.accountClientFinancialDetails['ConceitoCobrancaID']) {
			let obj = {
				ContaClienteId: this.guid,
				ConceitoCobrancaID: this.conceitoCobrancaEditValue
			}

			this.accountClientDetailsService.updateBillingConcept(obj).subscribe(result => {
				if (result.Success) {
					let novoConceito = this.conceptbillings.filter(f => f.ID == this.conceitoCobrancaEditValue)[0];

					this.accountClientFinancialDetails['ConceitoCobrancaID'] = this.conceitoCobrancaEditValue;
					this.accountClientFinancialDetails['ConceitoCobranca'] = novoConceito;

					this.flashMessagesService.show("Conceito atualizado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}

		// Retornar tela a condicao normal
		this.cancelClientFinanceiro();
	}

	reloadClient() {
		this.editingClient = false;
		$(".account-details-readyonly .form-group input, .account-details-readyonly .form-group select, .old-phones, #saveClient, #cancelClient, #addMorePhone, .editClient").hide();
		$(".account-details-readyonly .editable, #editClient").show();
		$(".account-details-readyonly .editable, #editCommercialStructure").prop("disabled", false);
	}

	cancelClient() {
		this.getAccountClientDetails();
		this.reloadClient();
		this.clearPhoneNumbers();
		this.validMail = true;
	}

	saveClient(accountClient, accountAllClientTypes: any, myForm: any, reloadAlcada) {
		if (!reloadAlcada) {
			const enum Enum {
				Residencial = 1,
				Celular = 2,
				Comercial = 3
			}

			var ListPhones = myForm.filter(opt => opt).map(opt => opt);

			for (let obj of ListPhones) {
				if (obj.Tipo != "" && obj.Telefone != "") {
					this.accountClientPhones.push({
						Ativo: true,
						ContaClienteID: this.guid,
						Telefone: obj.Telefone.toString(),
						Tipo: obj.Tipo.toString()
					})
				}
			}
			var clientType = $("#clientType").val();
			this.segmentClientID = $("#clientSegment").val();
			accountClient.DataNascimentoFundacao = this.dataFundacao ? this.dataFundacao.date.year + "-" + this.dataFundacao.date.month + "-" + this.dataFundacao.date.day : null;
			accountClient.TipoClienteID = clientType; //Set the id of Client Type before save
			accountClient.SegmentoID = this.segmentClientID; // Set the id of Segment of accountClient before save
		}

		console.log("Atualizando o cliente:", accountClient);

			this.accountClientDetailsService.updateClientDetails(
				this.token,
				this.guid,
				accountClient).subscribe(result => {
					if (!reloadAlcada) {
						if (this.accountClientPhones.length > 0) {
							this.accountClientDetailsService.insertAccountPhone(
								this.token,
								this.accountClientPhones).subscribe(result => {
									this.getAccountClientDetails();
								}, error => {
									this.flashMessagesService.show('Erro ao adicionar Outros Telefones.', { cssClass: 'alert-danger', timeout: 6000 });
								});
						}
						if (result.Success) {
							this.flashMessagesService.show('Dados Cadastrais atualizados com sucesso.', { cssClass: 'alert-success', timeout: 6000 });
							this.getAccountClientDetails();
						} else {
							result.Errors.forEach(error => {
								this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
							});
						}
					} else {
						this.router.navigateByUrl('/').then(
							() => {
								this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID + '/proposta-alcada');
							});
					}
				}, error => {
					this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
				});
		}

	//Check if nickname already exists in another Client.
	onSave() {
		let warning = "";
		this.accountClientDetailsService.checkNickName(this.token, this.accountClientDetails.Apelido, this.accountClientDetails.ID).subscribe(result => {
			if (result.Result == true && this.accountClientDetails.Apelido) {
				warning = "Apelido já utilizado em outro cliente."
			}
			this.showSaveModal(warning);
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	//Show confirmation Save Modal, receiving the warning message.
	showSaveModal(warning) {
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmar',
			message: 'Confirma as alterações na Conta Cliente?',
			warning: warning
		},
		{ backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe((isConfirmed) => {
			//We get dialog result
			if (isConfirmed) {
				this.saveClient(this.accountClientDetails, this.accountAllClientTypes.values, this.myForm.value.Telefone, false);
			}
			else {
				//Do nothing here for now
			}
		});
		//Close dialog calling disposable.unsubscribe();
		//If dialog was not closed manually close it by timeout
		setTimeout(() => {
			disposable.unsubscribe();
		}, 15000);
	}

	//Check the input and call the CEP service.
	onEditCEP() {
		this.validateCEP();
		if (this.validCEP == true) {
			this.accountClientDetailsService.viaCEP(this.accountClientDetails.CEP.replace('-', '')).subscribe(result => {
				if (result.erro) {
					this.flashMessagesService.show("CEP não encontrado!", { cssClass: 'alert-danger', timeout: 6000 });
				} else {
					this.accountClientDetails.Bairro = result.bairro;
					this.accountClientDetails.Cidade = result.localidade;
					this.accountClientDetails.Endereco = result.logradouro;
					this.accountClientDetails.UF = result.uf;
					this.flashMessagesService.show("Dados carregados por CEP", { cssClass: 'alert-success', timeout: 6000 });
				}
			}, error => {
				this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
			});

		}
	}

	//Validate if CEP is a complete field
	validateCEP() {
		if (this.accountClientDetails.CEP.length == 9) {
			this.validCEP = true;
		} else {
			this.validCEP = false;
		}
	}

	getClientGroupList() {
		if (this.permissoes['GrupoEconomico_Acesso']) {
			this.accountClientDetailsService.getEconomicGroups(this.guid, null).subscribe(result => {
				if (result.Result) {
					this.tempGroup = result.Result;
					console.log("Client Group", this.tempGroup);
					this.tempGroup.forEach(element => {
						this.temGrupoEconomigo = true;
						this.getGroupMembers(element.GrupoId);
					});
				}
			}, error => {
				this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
			});
		}
	}

	getGroupMembers(group) {
		this.accountClientDetailsService.getGroupMembers(group).subscribe(result => {
			if (result.Result) {
				let tempMembers = result.Result.MembrosDetalhes;
				this.clientByGroupList = this.clientByGroupList.concat(tempMembers);
				this.clientByGroupList = this.clientByGroupList.filter(item => item.ClienteId != this.guid);
				this.clientByGroupList = this.removeDuplicates(this.clientByGroupList, 'ClienteId');
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	//Remove Duplicated itens in array - receive array and a key to filter: removeDuplicates(myArray, 'myKey')
	removeDuplicates(arr, key) {
		if (!(arr instanceof Array) || key && typeof key !== 'string') {
			return [];
		}
		if (key && typeof key === 'string') {
			return arr.filter((obj, index, arr) => {
				return arr.map(mapObj => mapObj[key]).indexOf(obj[key]) === index;
			});
		} else {
			return arr.filter(function (item, index, arr) {
				return arr.indexOf(item) == index;
			});
		}
	}

	changeRoute(userID) {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + userID);
			});
	}

	changeRouteToCockpit() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/cockpit');
			});
	}


	getSerasaByID(serasaID) {
		this.accountClientDetailsService.requestSerasaByID(serasaID).subscribe(result => {
			if (result.Success) {
				const serasaObj = result.Result;

				if (this.accountClientDetails.TipoConsultaSolicitanteSerasaID == 3) {
					// Relato
					this.dialogService.addDialog(RelatoComponent,
					{
						serasaObj: serasaObj
					},
					{
						backdropColor: 'rgba(0, 0, 0, 0.5)'
					});
				} else if (this.accountClientDetails.TipoConsultaSolicitanteSerasaID == 2) {
					// CredNet
					this.dialogService.addDialog(CrednetComponent,
					{
						serasaObj: serasaObj
					},
					{
						backdropColor: 'rgba(0, 0, 0, 0.5)'
					});
				} else if (this.accountClientDetails.TipoConsultaSolicitanteSerasaID == 1) {
					// Concentre
					this.dialogService.addDialog(ConcentreComponent,
					{
						serasaObj: serasaObj
					},
					{
						backdropColor: 'rgba(0, 0, 0, 0.5)'
					});
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	checkAccountClientTribunal() {
		this.accountClientDetailsService.checkTribunal(this.guid).subscribe(result => {
			this.hasTJ = result.Success;
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	onRequestTribunal() {
		const objToSend = {
			ContaClienteID: this.guid,
			Documento: this.accountClientDetails.Documento
		};

		this.accountClientDetailsService.requestTribunal(objToSend).subscribe(result => {
			if (result.Success) {
				this.hasTJ = true;
				this.flashMessagesService.show("Documento enviado ao Tribunal de Justiça.", { cssClass: 'alert-success', timeout: 6000 });
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	onRequestSerasa() {
		if (!this.accountClientDetails.TipoClienteID || this.accountClientDetails.TipoClienteID == '00000000-0000-0000-0000-000000000000') {
			this.flashMessagesService.show("É necessário definir um Tipo para o cliente", { cssClass: 'alert-danger', timeout: 6000 });
		} else {
			this.accountClientDetailsService.checkSerasa(this.guid).subscribe(result => {
				if (result.Success) {
					this.dialogService.addDialog(SerasaConfirmComponent,
					{
						serasaObj: result.Result
					},
					{
						backdropColor: 'rgba(0, 0, 0, 0.5)'
					}).subscribe((isClosed) => {
						//We get dialog result
						if (isClosed) {
							this.requestSerasa();
						}
						else {
							//Do nothing here for now
						}
					});
				} else {
					this.requestSerasa();
				}
			}, error => {
				this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
			});
		}
	}

	requestSerasa() {
		this.accountClientDetailsService.requestSerasa(this.guid).subscribe(result => {
			if (result.Success) {
				if (this.accountClientDetails.TipoCliente && this.accountClientDetails.TipoCliente.TipoSerasa == 3) {
					// Relato
					this.dialogService.addDialog(RelatoComponent,
					{
						serasaObj: result.Result
					},
					{
						backdropColor: 'rgba(0, 0, 0, 0.5)'
					}).subscribe((isClosed) => {
						//We get dialog result
						this.getAccountClientDetails();
					});
				} else if (this.accountClientDetails.TipoCliente && this.accountClientDetails.TipoCliente.TipoSerasa == 2) {
					// CredNet
					this.dialogService.addDialog(CrednetComponent,
					{
						serasaObj: result.Result
					},
					{
						backdropColor: 'rgba(0, 0, 0, 0.5)'
					}).subscribe((isClosed) => {
						//We get dialog result
						this.getAccountClientDetails();
					});
				} else if (this.accountClientDetails.TipoCliente && this.accountClientDetails.TipoCliente.TipoSerasa == 1) {
					// Concentre
					this.dialogService.addDialog(ConcentreComponent,
					{
						serasaObj: result.Result
					},
					{
						backdropColor: 'rgba(0, 0, 0, 0.5)'
					}).subscribe((isClosed) => {
						//We get dialog result
						this.getAccountClientDetails();
					});
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				console.log(result);
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	requestCompetence() {
		this.accountClientDetailsService.createCommercialCompetence(this.clientID).subscribe(result => {
			if (result.Success) {
				this.accountClientDetails['PropostaAlcadaID'] = result.Result.ID;
				this.accountClientDetails['PropostaAlcadaStatusID'] = result.Result.PropostaCobrancaStatusID;
				this.router.navigateByUrl('/').then(
					() => {
						this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID + '/proposta-alcada');
					});
				//this.saveClient(this.accountClientDetails, this.accountAllClientTypes.values, this.myForm.value.Telefone, true);
				//console.log("AH", this.accountClientDetails);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				console.log(result);
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	validateProposal() {
		if (this.competenceProposalPermission()) {
			this.accountClientDetailsService.validateProposalCommercialCompetence(this.clientID).subscribe(result => {
				if (result.Success) {
					this.requestCompetence();
				} else {
					this.dialogService.addDialog(AlcadaAlertComponent,
						{
							errors: result.Errors
						},
						{
							backdropColor: 'rgba(0, 0, 0, 0.5)'
						});
				}
			}, error => {
				this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
			});
		}
	}

	validateExtraProposal() {
		if (this.extraProposalPermission()) {
			this.dialogService.addDialog(SolicitarLcAdicionalComponent,
				{
					clientID: this.clientID,
					vigenciaLC: this.accountClientFinancialDetailsRaw['Limites'].find(f => f.EmpresasID === this.empresa).VigenciaFim
				},
				{
					backdropColor: 'rgba(0, 0, 0, 0.5)'
				}).subscribe((solicitacaoLcAdicionalData) => {
					console.log('solicitacaoLcAdicionalData', solicitacaoLcAdicionalData);
								
					if(solicitacaoLcAdicionalData) {					
						this.limiteAdicionalProposalService.sendExtraLimitProposal({
							LCAdicional: solicitacaoLcAdicionalData.valorSolicitado,
							VigenciaAdicional: moment(solicitacaoLcAdicionalData.vigencia.jsdate).toDate(),
							Parecer: solicitacaoLcAdicionalData.justificativa,
							AcompanharProposta: solicitacaoLcAdicionalData.keepProposal,
							CodigoSap: solicitacaoLcAdicionalData.codigoSap,
							ContaClienteID: this.clientID
						}).subscribe(extraLimitProposal => {
								console.log('extraLimitProposal', extraLimitProposal);

								if (extraLimitProposal.Success) {		
									this.flashMessagesService.show('Proposta solicitada com sucesso!', { cssClass: 'alert-success', timeout: 6000 });							
									this.accountClientDetailsService.getCreditProposal(this.guid).subscribe(creditProposal => {
										console.log('creditProposal', creditProposal);

										if (creditProposal.Success) {
											
											const hasAnexo = solicitacaoLcAdicionalData.fileSource.size > 0
											
											if(!hasAnexo) {
												this.router.navigateByUrl('/').then(
													() => {
														this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID + '/proposta-la');
													});
											} else {
												var formData = new FormData();
												formData.append('Arquivo', solicitacaoLcAdicionalData.fileSource);
												formData.append('PropostaLCAdicionalID', creditProposal.Result.PropostaLCAdicionalID);
												formData.append('AnexoID', '');
												formData.append('ContaClienteID', '');
												formData.append('CategoriaDocumento', '13'.toString());
												formData.append('DescricaoAnexo', solicitacaoLcAdicionalData.fileDescription);

												this.showLoader = true;
												
												this.attachmentsenderService.saveAttachment(this.token, formData).subscribe(attachmentSaved => {
													if (attachmentSaved.Success) {														
														this.flashMessagesService.show("Anexo enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });															
													} else {
														this.showLoader = false;
														this.flashMessagesService.show(attachmentSaved.Errors, { cssClass: 'alert-danger', timeout: 6000 });
													}
													this.router.navigateByUrl('/').then(
														() => {
															this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID + '/proposta-la');
														});
												}, error => {
													this.showLoader = false;
													console.log(error);
												});
											}
										}
									}, error => {
										console.log(error);
										return false;
									});								
								} else {
									this.flashMessagesService.show(extraLimitProposal.Errors, { cssClass: 'alert-danger', timeout: 6000 });
									console.log(extraLimitProposal);
								}
							}, 
							error => {
								this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
							});
					}
				});
		}
	}

	reevaluateWallet() {
		this.accountClientDetailsService.reevaluateWallet(this.clientID).subscribe(result => {
			if (result.Success) {
				if (result.Result) {
					this.flashMessagesService.show("Reavaliação da carteira solicitada com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				}
				else {
					this.flashMessagesService.show("Erro ao solicitar reavaliação de carteira", { cssClass: 'alert-danger', timeout: 6000 });
				}
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	refreshPage() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID);
			});
	}

	getRegistrationForm() {
		let myFile = "/assets/files/ficha_cadastral.xlsx";
		var a = document.createElement('a');
		a.href = myFile;
		a.download = myFile.substr(myFile.lastIndexOf('/') + 1);
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/account-client-details.component.ts